<script>
import { Bar } from 'vue-chartjs'
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'
import DateFormatter from '../../plugins/dateFormatter'
export default {
  extends: Bar,
  props: ['height'],
  data: () => {
    return {
      chartData: {},
      dates: [],
      bounceRate: []
    }
  },
  async mounted () {
    if(this.$store.state.request){
    setTimeout(() => { 
    const datasets1 = [
      {
        label: 'Percent',
        backgroundColor: '#fff',
        borderColor: 'transparent',
        data: []
      }
    ]
    
    this.chartData = this.$store.state.mainOverviewsData.datas[0].onediocomDatas
    this.chartData.forEach(element => {
      this.dates.push(DateFormatter(element.data_date))
      this.bounceRate.push(parseInt(element.bounce_rate));  
    });
    datasets1[0].data = this.bounceRate
    
    //console.log(this.bounceRate)
    this.renderChart(
      {
        labels: this.dates,
        datasets: datasets1
      },
      {
        tooltips: {
          enabled: false,
          custom: CustomTooltips
        },
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            display: false,
            categoryPercentage: 1,
            barPercentage: 0.1
          }],
          yAxes: [{
            display: false  
          }]
        }
      }
    )
    }, 2000);
    }
  }
}
</script>
